var __TEMP__ = require('./_baseDifference.js');var baseDifference = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_baseFlatten.js');var baseFlatten = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_baseRest.js');var baseRest = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./isArrayLikeObject.js');var isArrayLikeObject = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./last.js');var last = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * This method is like `_.difference` except that it accepts `comparator`
 * which is invoked to compare elements of `array` to `values`. The order and
 * references of result values are determined by the first array. The comparator
 * is invoked with two arguments: (arrVal, othVal).
 *
 * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 *
 * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
 * // => [{ 'x': 2, 'y': 1 }]
 */
var differenceWith = baseRest(function(array, values) {
  var comparator = last(values);
  if (isArrayLikeObject(comparator)) {
    comparator = undefined;
  }
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
    : [];
});

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = differenceWith;
